export default function SuspendedSellerCheck() {
	const suspended = $('#suspended-seller-modal');
	if (suspended.length > 0) {
		suspended.modal('show');
		suspended.on('hidden.bs.modal', function () {
			$('#suspended-seller-modal').modal('show');
		});
	}
}
